import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { Advisor } from "../Types";
const Response = z.object({
    advisors: Advisor.array(),
});
/**
 *
 * queryParam is an optional value that can either return all employees or
 * filter out those with the 'Engineering' role assigned.
 */
export const url = (queryParam = "All") => {
    const queryString = queryParam === "NoEng" ? "?noEng=true" : "";
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/entity/v1/advisors${queryString}`
        : `https://middleware.uat.farther.com/entity/v1/advisors${queryString}`;
};
/**
 *
 * queryParam is an optional value that can either return all employees or
 * filter out those with the 'Engineering' role assigned.
 */
export default async function getFartherEmployees(queryParam, config) {
    const { data } = await axios.get(url(queryParam), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getFartherEmployees] Could not parse";
        errorLog("getFartherEmployees", JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getFartherEmployees.js.map